import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FileUploadModule } from 'ng2-file-upload';

import { JYoguiSharedModule } from '../../shared';

import { EventComponent, eventRoute,
    eventPopupRoute, EventDetailComponent,
    EventDetailNoAuthComponent,
    EventPopupService, EventDialogComponent,
    EventPopupComponent, EventResolvePagingParams,
    EventService, EventUtilService,
    EventDeleteDialogComponent,
    EventDeletePopupComponent} from './';



let ENTITY_STATES = [
    ...eventRoute,
    ...eventPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
        FileUploadModule
    ],
    declarations: [
        EventPopupComponent,
        EventComponent,
        EventDetailComponent,
        EventDetailNoAuthComponent,
        EventDialogComponent,
        EventDeleteDialogComponent,
        EventDeletePopupComponent
    ],
    entryComponents: [
        EventPopupComponent,
        EventComponent,
        EventDialogComponent,
        EventDeleteDialogComponent,
        EventDeletePopupComponent
    ],
    providers: [
        EventPopupService,
        EventResolvePagingParams,
        EventService,
        EventUtilService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiEventModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event.module.ts